
import { useEffect } from 'react';

const Title = (title) => {
    
    useEffect(() => {
        document.title = `${title.set} | Kingsley Bate`;

        // Update meta description if provided
        if (title.description) {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.name = 'description';
                document.head.appendChild(metaDescription);
            }
            metaDescription.content = title.description;
        }
    }, [title.set, title.description]);

}

export default Title;